import { get } from '../../../app/services/http';
const headers = { 'Content-Type': 'application/json' };
/**
 * Client Terms and Conditions
 */
export function getTermsAndConditionsPolicy() {
  const url = '/rest/v1/policy/terms-and-conditions';
  return get({ url, headers });
}

/**
 * Client Privacy Policy
 */
export function getPrivacyPolicy() {
  const url = '/rest/v1/policy/privacy';
  return get({ url, headers });
}
